import { render, staticRenderFns } from "./Lecture.vue?vue&type=template&id=4858f5bb&scoped=true"
import script from "./Lecture.vue?vue&type=script&lang=js"
export * from "./Lecture.vue?vue&type=script&lang=js"
import style0 from "./Lecture.vue?vue&type=style&index=0&id=4858f5bb&prod&lang=scss&scoped=true"
import style1 from "./Lecture.vue?vue&type=style&index=1&id=4858f5bb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4858f5bb",
  null
  
)

export default component.exports